import React, { useState, Component, useEffect } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { loadPeriodos } from '../../store/actions/Periodos';

import ClearOutlinedIcon from '@material-ui/icons/ClearOutlined';
import CheckOutlinedIcon from '@material-ui/icons/CheckOutlined';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import Alert from '@material-ui/lab/Alert';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import RefreshIcon from '@material-ui/icons/Refresh';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';

import Dialog from '../../components/Dialog/Dialog';
import { ButtonDefault, ButtonPrimary } from '../../components/Button/Button';
import { ButtonSave, ButtonClear } from '../../forms/Buttons/ButtonsForm';
import Text from '../../components/Inputs/Text/Text';
import Toast from '../../components/Toast/Toast';

import CandidatoService from '../../services/Candidato';
import DocumentoService from '../../services/Documento';
import TratamentoService from '../../services/Tratamento';
import { errors } from '../../services/API';

import DocumentoViewer from '../../forms/Documento/DocumentoViewer';

import { isBlank, isBlankHelperText } from '../../helper/ValidationHelper';
import { getFilenameResponse, base64ToFile } from '../../helper/FileHelper';

import LinkTargetBlank from '../../components/Link/Link';
import { patternNome } from '../Candidato/Candidato';

export const ButtonsTratamentoListaDocumentos = ({ onTratarFila, onLimparFila, refreshFilaTratamento, loadingFilaTratamento, loadingLimparFilaTratamento }) => {
    const [quantidadeDocumentosEmTratamento, setQuantidadeDocumentosEmTratamento] = useState(0);
    const [quantidadeDocumentosAguardando, setQuantidadeDocumentosAguardando] = useState(0);

    useEffect(() => {
        TratamentoService.documentos()
            .then(res => {
                setQuantidadeDocumentosEmTratamento(res.data.documentos.emTratamento);
                setQuantidadeDocumentosAguardando(res.data.documentos.aguardando);
            });
    }, [refreshFilaTratamento]);

    return (
        <Grid item xs={12}>
            <Grid container spacing={2} alignItems="center">
                {quantidadeDocumentosAguardando > 0 && (
                    <Grid item>
                        <ButtonSave
                            startIcon={<AssignmentTurnedInIcon />}
                            onClick={onTratarFila}
                            name={'Realizar Tratamento em Fila Documentos'}
                            loading={loadingFilaTratamento}
                        />

                    </Grid>
                )}
                {quantidadeDocumentosEmTratamento > 0 && (
                    <Grid item>
                        <ButtonClear
                            startIcon={<RefreshIcon />}
                            onClick={onLimparFila}
                            name={`Liberar (${quantidadeDocumentosEmTratamento}) documentos na fila para tratamento`}
                            color="secondary"
                            loading={loadingLimparFilaTratamento}
                        />
                    </Grid>
                )}
            </Grid>
        </Grid>
    )
}

export class DialogTratamentoFilaDocumentos extends Component {
    constructor(props) {
        super(props);
        props.parentRef(this);
        this.state = {
            open: false,
            loading: false,
            documento: null,
            file: null,
            status: '',
            justificativa: '',
            escolaInvalida: false,
            escolaEmAnalise: false,
            errors: {
                status: false,
                justificativa: false,
            },
            helpers: {
                status: null,
                justificativa: null,
            },
        }
    }

    setToast = t => this.Toast = t;

    toBase64 = (blob) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);

            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
        });
    };

    openModal = () => {
        this.props.loadingFilaTratamento(true);
        this.handleProximo();
    }

    handleClose = () => {
        this.setState({ open: false });
        this.props.handleClose && this.props.handleClose();
    }

    handleChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            errors: { ...this.state.errors, [e.target.name]: false },
            helpers: { ...this.state.helpers, [e.target.name]: null },
        });
    }

    carregarDocumentoAtual = (documento) => {
        this.setState({ loading: true });

        CandidatoService.downloadDocumento(documento.candidato.id, documento.id)
            .then(res => {
                const fileName = getFilenameResponse(res);

                this.toBase64(res.data).then(base64 => {
                    const file = base64ToFile(base64, fileName);

                    this.setState({
                        open: true,
                        loading: false,
                        documento: documento,
                        file: file,
                        status: '',
                        justificativa: documento.validacao.justificativa,
                        escolaInvalida: documento?.candidato?.escola?.invalida,
                        escolaEmAnalise: documento?.candidato?.escola?.status === 'EM_ANALISE',
                    });
                });
            })
            .catch(error => {
                const e = errors(error);
                this.Toast.setState({
                    message: {
                        message: e.message,
                        type: e.type,
                        open: true
                    }
                });
            }).finally(() => {
                this.setState({ loading: false });
            });
    };

    handleProximo = () => {
        this.setState({ loading: true });

        DocumentoService.next()
            .then(res => {
                const documento = res.data;
                if (!documento) {
                    this.Toast.setState({
                        message: {
                            message: "Não existem mais documentos na fila",
                            type: "info",
                            open: true
                        }
                    });
                    this.handleClose();
                    return;
                }

                this.carregarDocumentoAtual(documento);
            })
            .catch(error => {
                const e = errors(error);
                this.Toast.setState({
                    message: {
                        message: e.message,
                        type: e.type,
                        open: true
                    }
                });
            }).finally(() => {
                this.setState({ loading: false });
                this.props.loadingFilaTratamento(false);
            });
    };

    isValid = () => {
        const { status, justificativa } = this.state;

        const statusInvalido = isBlank(status);
        const justificativaInvalida = status === 'INVALIDO' && isBlank(justificativa);

        if (statusInvalido || justificativaInvalida) {
            this.setState({
                errors: {
                    status: statusInvalido,
                    justificativa: justificativaInvalida,
                },
                helpers: {
                    status: statusInvalido ? isBlankHelperText() : null,
                    justificativa: justificativaInvalida ? isBlankHelperText() : null,
                },
            });
            return false;
        }
        return true;
    }

    handleConfirm = () => {
        this.setState({ loading: true });

        if (!this.isValid() || this.state.escolaInvalida || this.state.escolaEmAnalise) {
            this.setState({ loading: false });
            return;
        }

        const { documento, status, justificativa } = this.state;

        const tratamento = {
            status,
            justificativa,
        }

        CandidatoService.tratarDocumento(documento.candidato.id, documento.id, tratamento)
            .then(() => {
                this.handleProximo();
            })
            .catch(error => {
                const e = errors(error);
                this.Toast.setState({
                    message: {
                        message: e.message,
                        type: e.type,
                        open: true
                    }
                });
            })
            .finally(() => {
                this.setState({ loading: false });
            });
    }

    componentDidMount() {
        this.props.loadPeriodos();
        window.addEventListener('keydown', this.handleKeyDown);
    }

    componentWillUnmount() {
        window.removeEventListener('keydown', this.handleKeyDown);
    }

    handleKeyDown = (e) => {
        if (!this.state.open) return;

        const tag = e.target.tagName.toLowerCase();
        if (tag === 'input' || tag === 'textarea') return;

        switch (e.key) {
            case 'v':
            case 'V':
                this.setState({ status: 'VALIDO' },
                    this.handleConfirm);
                break;
            case 'i':
            case 'I':
                e.preventDefault();
                this.setState({ status: 'INVALIDO' });
                break;
            case 'ArrowRight':
                this.handleProximo();
                break;
            default:
                break;
        }
    };

    render() {

        return (
            <>
                <Toast parentRef={this.setToast} />

                <Dialog
                    openDialog={this.state.open}
                    title={"Tratamento de Comprovante de Vínculo de Candidato"}
                    closeDialog={this.handleClose}
                    actions={
                        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
                            <div>
                                <ButtonDefault
                                    onClick={this.handleProximo}
                                    endIcon={<ArrowForwardIcon />}
                                    name="Próximo Documento"
                                    style={{ margin: 4 }}
                                    disabled={this.state.loading}
                                />
                            </div>
                            <div>
                                <ButtonDefault
                                    onClick={this.handleClose}
                                    startIcon={<ClearOutlinedIcon />}
                                    name="Fechar"
                                    style={{ margin: 4 }}
                                    color="secondary"
                                />
                            </div>
                        </div>
                    }
                    fullWidth
                    maxWidth="lg"
                >
                    <div style={{ height: '70vh', display: 'flex', flexDirection: 'column' }}>
                        {this.state.escolaInvalida ? (
                            <Grid item style={{ marginBottom: 16 }}>
                                <Alert severity="error">
                                    <b>ATENÇÃO:</b> A escola <b>{this.state.documento?.candidato?.escola?.inep} - {this.state.documento?.candidato?.escola?.nome} - {this.state.documento?.candidato?.escola?.dependenciaAdministrativa}</b> selecionada pelo candidato foi <b>Reprovada</b> pela equipe da OBMEP. 
                                    <br />
                                    Não é Possível Tratar o Documento de uma Escola que não é Válida.
                                    <br />
                                    <LinkTargetBlank link={`${process.env.REACT_APP_PUBLIC_MIRIM_URL}/admin/escola/${this.state.documento?.candidato?.escola?.inep}/editar#ocorrencias`}>CLIQUE AQUI</LinkTargetBlank> para visualizar o tratamento desta escola.
                                </Alert>
                            </Grid>
                        ) : this.state.escolaEmAnalise ? (
                            <Grid item style={{ marginBottom: 16 }}>
                                <Alert severity="warning">
                                    <b>ATENÇÃO:</b> A escola <b>{this.state.documento?.candidato?.escola?.inep} - {this.state.documento?.candidato?.escola?.nome} - {this.state.documento?.candidato?.escola?.dependenciaAdministrativa}</b> selecionada pelo candidato está sendo analisada pela equipe da OBMEP. 
                                    <br />
                                    Não é Possível Tratar o Documento de uma Escola que não é Válida.
                                    <br />
                                    <LinkTargetBlank link={`${process.env.REACT_APP_PUBLIC_MIRIM_URL}/admin/escola/${this.state.documento?.candidato?.escola?.inep}/editar#ocorrencias`}>CLIQUE AQUI</LinkTargetBlank> para realizar o tratamento desta escola.

                                </Alert>
                            </Grid>
                        ) : (
                            <Grid item style={{ marginBottom: 16 }}>
                                <Alert severity="info">
                                    A escola <b>{this.state.documento?.candidato?.escola?.inep} - {this.state.documento?.candidato?.escola?.nome} - {this.state.documento?.candidato?.escola?.dependenciaAdministrativa}</b> foi selecionada pelo candidato.
                                </Alert>
                            </Grid>
                        )}

                        <Grid container spacing={3} style={{ flex: 1, minHeight: 0 }}>
                            <Grid item xs={12} md={8} xl={8}>
                                <DocumentoViewer file={this.state.file} withRotate={true} />
                            </Grid>

                            <Grid item xs={12} md={4} xl={4} style={{ display: 'flex', minHeight: 0 }}>
                                <Grid
                                    container
                                    direction="column"
                                    style={{
                                        height: '100%',
                                    }}
                                >
                                    <Grid item>
                                        <Grid container spacing={2} direction="column">
                                            <Grid item>
                                                <Typography variant="subtitle2" color="textSecondary">
                                                    Candidato
                                                </Typography>
                                                <Typography variant="body1" style={{ marginBottom: 10 }}>
                                                    {patternNome(this.state.documento?.candidato?.nomeExibicao, this.state.documento?.candidato?.nomeSocial,this.state.documento?.candidato?.nome)}
                                                </Typography>
                                            </Grid>
                                            <Grid item>
                                                <Typography variant="subtitle2" color="textSecondary">
                                                    Tipo de Documento
                                                </Typography>
                                                <Typography variant="body1">
                                                    {this.state.documento?.tipo?.nome || '-'}
                                                </Typography>
                                            </Grid>

                                            <Grid item>

                                                {!this.state.status && (!this.state.escolaInvalida && !this.state.escolaEmAnalise) && (
                                                    <>
                                                        <Typography variant="subtitle2" color="textSecondary">
                                                            Validação
                                                        </Typography>
                                                        <div style={{ display: 'flex', gap: 8 }}>
                                                            <ButtonPrimary
                                                                name="Validar"
                                                                fullWidth
                                                                startIcon={<CheckOutlinedIcon />}
                                                                onClick={() => { this.setState({ status: 'VALIDO' }, this.handleConfirm); }}
                                                                style={{ height: 30 }}
                                                            />

                                                            <ButtonDefault
                                                                name="Invalidar"
                                                                fullWidth
                                                                startIcon={<ClearOutlinedIcon />}
                                                                onClick={() => { this.setState({ status: 'INVALIDO' }) }}
                                                                style={{ backgroundColor: '#f44336', color: 'white', height: 30 }}
                                                            />
                                                        </div>
                                                    </>
                                                )}

                                                {(this.state.status === 'INVALIDO' && !this.state.escolaInvalida && !this.state.escolaEmAnalise) && (
                                                    <div style={{ display: 'flex', gap: 8 }}>
                                                        <ButtonDefault
                                                            name="Cancelar Invalidação"
                                                            fullWidth
                                                            startIcon={<ArrowBackIcon />}
                                                            onClick={() => { this.setState({ status: '' }) }}
                                                            style={{ height: 30 }}
                                                        />
                                                        <ButtonPrimary
                                                            onClick={this.handleConfirm}
                                                            startIcon={<CheckOutlinedIcon />}
                                                            name="Confirmar Invalidação"
                                                            fullWidth
                                                            style={{ backgroundColor: '#f44336', color: 'white', height: 30 }}
                                                            loading={this.state.loading}
                                                        />
                                                    </div>
                                                )}
                                            </Grid>

                                            {((this.state.status === 'INVALIDO' || this.state.justificativa) && !this.state.escolaInvalida && !this.state.escolaEmAnalise) && (
                                                <Grid item>
                                                    <Text
                                                        required={this.state.status === 'INVALIDO'}
                                                        autoFocus
                                                        label="Justificativa"
                                                        name="justificativa"
                                                        value={this.state.justificativa}
                                                        error={this.state.errors.justificativa}
                                                        onChange={this.handleChange}
                                                        helperText={this.state.helpers.justificativa}
                                                        multiline
                                                        rows={4}
                                                    />
                                                </Grid>
                                            )}

                                        </Grid>
                                    </Grid>

                                    <Grid item style={{ marginTop: 'auto' }}>
                                        <div style={{ borderTop: '1px solid #eee', paddingTop: 10 }}>
                                            <Typography
                                                color="textSecondary"
                                                style={{
                                                    marginTop: 8,
                                                    wordBreak: 'break-word',
                                                    overflowWrap: 'break-word'
                                                }}
                                            >
                                                Atalhos: <br /> V = Validar | I = Invalidar | → = Próximo
                                            </Typography>

                                            <br />
                                            <Typography
                                                style={{ wordBreak: 'break-word', overflowWrap: 'break-word' }}
                                            >
                                                Ao clicar em "Validar", o documento atual será aprovado e o próximo da fila será carregado automaticamente.<br />
                                                Ao clicar em "Invalidar", informe uma justificativa e clique em "Confirmar Invalidação". O documento será reprovado e o próximo será carregado. Clicar em "Cancelar Invalidação" irá cancelar a ação e manter o documento atual para validação.
                                            </Typography>
                                        </div>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </div>
                </Dialog >
            </>
        );
    }
}

const mapStateToProps = state => ({ contexts: state.periodos });
const mapDispatchToProps = dispatch => (bindActionCreators({ loadPeriodos }, dispatch));

export default connect(mapStateToProps, mapDispatchToProps)(DialogTratamentoFilaDocumentos);
